/* eslint-disable @typescript-eslint/no-explicit-any */
import BannersLayout from './BannersLayout'
import BannersLogic from './BannersLogic'

const Banners = ({ className }: any) => {
  return <BannersLogic className={className} Wrapper={BannersLayout} />
}

export default Banners
